"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var transformState = function transformState() {
  var stateMap = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var state = arguments.length > 1 ? arguments[1] : undefined;
  var key = arguments.length > 2 ? arguments[2] : undefined;
  var outObj = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  //状态解析 状态map，状态值，状态key
  if (!toString(state) || !stateMap.length) {
    //没有状态值或者状态map，返回未知状态
    return '';
  }
  ;
  var stateObj = stateMap.find(function (item) {
    return item[key || 'id'] == state;
  }) || {};
  var outInfo = outObj ? stateObj : stateObj.label || '';
  return outInfo;
};
var _default = exports.default = transformState;